import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Privacy.css';

function Privacy() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Navbar rendert zichzelf niet in de native app (zie Navbar.js) - zonder
  // vervanging zou een ingelogde gebruiker die hier via het profielmenu
  // terechtkomt helemaal geen manier hebben om terug te navigeren (geen
  // navbar, geen systeem-terugknop in de Capacitor WebView). Vandaar deze
  // native-only terugknop, enkel zichtbaar wanneer Navbar zelf niets toont.
  const isNative = localStorage.getItem('isNativeApp') === 'true';

  useEffect(() => {
    document.title = 'SmartStays - Privacybeleid';
  }, []);

  const sections = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="privacy-container">
      <Navbar />
      {isNative && (
        <div className="legal-native-bar">
          <button type="button" className="native-detail-back" onClick={() => navigate(-1)} aria-label={t('common.back')}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 6l-6 6 6 6" /></svg>
          </button>
        </div>
      )}

      <div className="privacy-content">
        <h1>{t('privacy.title')}</h1>
        <p className="privacy-updated">{t('privacy.updated')}</p>
        <p className="privacy-intro">{t('privacy.intro')}</p>

        {sections.map((n) => (
          <section className="privacy-section" key={n}>
            <h2>{t(`privacy.section${n}Title`)}</h2>
            <p>{t(`privacy.section${n}Text`)}</p>
          </section>
        ))}

        <section className="privacy-section">
          <h2>{t('privacy.contactTitle')}</h2>
          <p>
            {t('privacy.contactText')}{' '}
            <a href="mailto:info@smartstays.be">info@smartstays.be</a>
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default Privacy;
